import { useBreakpoint, Breakpoints } from './useBreakpoint';

export const useIsTablet = () => !useBreakpoint(Breakpoints.SM_MAX);
